
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/why-cure",
      function () {
        return require("private-next-pages/why-cure.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/why-cure"])
      });
    }
  